if (!customElements.get('one-time-sub-options')) {
  class OneTimeSubOptions extends HTMLElement {
    connectedCallback() {
      // Get the form element
      this.form = this.closest('form');

      // Get one-time purchase bottle options (now just buttons, not radio inputs)
      this.bottleOptions = this.querySelectorAll('input[name="bottle_option"]');

      // Get subscription options
      this.subscriptionOptions = this.querySelectorAll('input[name="selling_plan"][type="checkbox"]');

      // Get the quantity input
      this.quantityInput = document.querySelector('.m-quantity__input') || document.querySelector('input[name="quantity"]');

      // Track currently selected subscription
      this.selectedSubscription = null;

      // Reset to initial state on page load
      this.setInitialState();

      // Add click handlers to label elements to ensure radio selection
      const bottleLabels = this.querySelectorAll('.otp.option');
      const subscriptionLabels = this.querySelectorAll('.subscription.option');

      // Handle clicks on bottle option divs - these now just update quantity
      bottleLabels.forEach(button => {
        button.style.cursor = 'pointer';
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const quantity = button.dataset.quantity || button.querySelector('input[name="bottle_option"]')?.value;
          if (quantity) {
            this.setQuantity(quantity);
            // Remove selected class from all bottle options first
            this.clearBottleSelections();
            // Add selected to the clicked one
            button.classList.add('selected');
          }
        });
      });

      // Handle clicks on subscription labels - allow toggle on/off
      subscriptionLabels.forEach(label => {
        label.style.cursor = 'pointer';
        label.addEventListener('click', (e) => {
          // If not clicking the checkbox directly
          if (e.target.type !== 'checkbox') {
            e.preventDefault();
            const checkbox = label.querySelector('input[type="checkbox"]');
            if (checkbox) {
              // Toggle the checkbox
              checkbox.checked = !checkbox.checked;
              // Trigger change event to handle the logic
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      });

      // Listen to subscription checkbox changes
      this.subscriptionOptions.forEach(option => {
        option.addEventListener('change', (e) => {
          if (e.target.checked) {
            this.setSellingPlan(e.target.value);
            this.selectedSubscription = e.target.value;
          } else {
            this.clearSellingPlan();
            this.selectedSubscription = null;
          }
          this.updateVisualStates();
        });
      });

      // Listen to quantity changes
      if (this.quantityInput) {
        const handleQuantityChange = (e) => {
          const quantity = parseInt(e.target.value) || 1;

          // Clear all bottle selections first
          this.clearBottleSelections();

          // If quantity <= 3, find and select the matching bottle option
          if (quantity <= 3) {
            const matchingButton = Array.from(this.querySelectorAll('.otp.option')).find(button => {
              const buttonQuantity = button.dataset.quantity || button.querySelector('input[name="bottle_option"]')?.value;
              return parseInt(buttonQuantity) === quantity;
            });

            if (matchingButton) {
              matchingButton.classList.add('selected');
            }
          }
        };

        this.quantityInput.addEventListener('change', handleQuantityChange);
        this.quantityInput.addEventListener('input', handleQuantityChange);
      }

      // Listen to add to cart button clicks
      const addToCartButton = document.querySelector('.main-product__block-one_time_sub_options .m-add-to-cart');
      console.log(addToCartButton)
      if (addToCartButton) {
        addToCartButton.addEventListener('click', () => {
          console.log('clicked')
          // Clear all bottle selections after add to cart
          setTimeout(() => {
            this.clearBottleSelections();
          }, 100); // Small delay to ensure cart has processed
        });
      }

    }

    setInitialState() {
      // Clear all selections
      this.subscriptionOptions.forEach(option => {
        option.checked = false;
      });

      // Reset quantity to 1
      if (this.quantityInput) {
        this.quantityInput.value = 1;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Clear any selling plan
      this.clearSellingPlan();
      this.selectedSubscription = null;

      // Update visual states
      this.updateVisualStates();
    }

    setQuantity(value) {
      if (this.quantityInput) {
        this.quantityInput.value = value;
        // Dispatch change event to trigger quantity input's validation
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    clearBottleSelections() {
      // Remove selected class from all bottle option buttons
      this.querySelectorAll('.otp.option').forEach(button => {
        button.classList.remove('selected');
      });
    }

    updateVisualStates() {
      // Update subscription container visual state
      const subscriptionContainer = this.querySelector('.purchase-option.subscription');
      const hasSubscriptionSelected = Array.from(this.subscriptionOptions).some(opt => opt.checked);

      if (subscriptionContainer) {
        subscriptionContainer.classList.toggle('active', hasSubscriptionSelected);
      }

      // Update subscription option labels
      this.querySelectorAll('.subscription.option').forEach(label => {
        const input = label.querySelector('input[type="checkbox"]');
        if (input && input.checked) {
          label.classList.add('selected');
        } else {
          label.classList.remove('selected');
        }
      });
    }

    clearSellingPlan() {
      // Remove any existing hidden selling plan input
      const existingInput = this.form?.querySelector('input[name="selling_plan"][type="hidden"]');
      if (existingInput) {
        existingInput.remove();
      }
    }

    setSellingPlan(planId) {
      // Clear any existing selling plan first
      this.clearSellingPlan();

      // Create hidden input for selling plan if we have a form and planId
      if (this.form && planId) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'selling_plan';
        hiddenInput.value = planId;
        this.form.appendChild(hiddenInput);
      }
    }
  }

  customElements.define('one-time-sub-options', OneTimeSubOptions);
}